/**
 * Get GTM dataLayer
 *
 * @returns {*|null}
 */
export function getDataLayer() {
    return 'undefined' !== typeof dataLayer ? dataLayer : null;
}
